import React, { FC } from 'react'
import { CouponItem } from '@cps'
import PromoCode from './CouponItem'
import DiablePromoCode from './CouponDisabledItem'
import './couponList.scss'

interface IProps {
  coupons: (IDiscountItemCoupon | IDiscountCoupon)[];
  /** 是否是删除样式 */
  isDelete?: boolean;
  /** 是否是优惠码 */
  isPromoCode?: boolean;
  onUseClick: (coupon) => void;
}

const CouponList: FC<IProps> = ({
  coupons,
  onUseClick,
  isPromoCode,
  isDelete = false,
}) => {
  const useCoupon = coupons.filter((coupon) => coupon.status !== 'disable')
  const unuseCoupon = coupons.filter((coupon) => coupon.status === 'disable')
  return (
    <div className='counpon-list-wrapper'>
      <div className='coupon-list'>
        {useCoupon.map((coupon, index) => {
          return isPromoCode ? (
            <PromoCode
              isDelete={isDelete}
              coupon={coupon}
              key={coupon.memberCouponId}
              onClick={() => onUseClick(coupon)}
            />
          ) : (
            <CouponItem
              type='use'
              couponInfo={coupon}
              selected={coupon.isSelect}
              key={index}
              onClick={() => onUseClick(coupon)}
            >
            </CouponItem>
          )
        })}
      </div>
      {unuseCoupon.length ? (
        <div className='unuse-wrapper'>
          <div className='title'>{i18n.t('cart.couponUnuseTitle')}</div>
          <div className='disabled-coupon-list'>
            {unuseCoupon.map((coupon, index) => {
              return isPromoCode ? (
                <DiablePromoCode coupon={coupon} key={coupon.memberCouponId} />
              ) : (
                <CouponItem
                  type='use'
                  couponInfo={coupon}
                  selected={coupon.isSelect}
                  key={index}
                  unavailable
                >
                </CouponItem>
              )
            })}
          </div>
        </div>
      ) : null}
      {!useCoupon.length && !unuseCoupon.length && (
        <div className='no-coupon-wrap'>
          <div>
            <i className='iconfont icon-kongzhuangtai2x'></i>
          </div>
        </div>
      )}
    </div>
  )
}

export default CouponList
